import { Record, List, fromJS } from 'immutable';
import { workflowsRoutes } from 'constants/routes';

const defaultValues = {
  workflowId: 0,
  workflowName: '',
  stepStatus: new List(),
};

export default class Workflow extends Record(defaultValues, Workflow) {
  constructor(values) {
    super({
      ...values,
      stepStatus: values && values.stepStatus ? fromJS(values.stepStatus) : new List(),
    });
  }

  getCurrentStepStatus() {
    const stepStatus = this.get('stepStatus');
    if (!stepStatus.isEmpty()) {
      return stepStatus.find(step => {
        const completeDateTime = step.get('completeDateTime');
        const required = step.get('required');
        return !completeDateTime && required ? step : undefined;
      });
    }
    return undefined;
  }

  getStepStatusByName(processStepName) {
    const stepStatus = this.get('stepStatus');
    return stepStatus.find(step => {
      return step.get('processStepName') === processStepName ? step : undefined;
    });
  }

  getStepStatusById(processStepId) {
    const stepStatus = this.get('stepStatus');
    return stepStatus.find(step => {
      return step.get('processStepId') === processStepId ? step : undefined;
    });
  }

  getStepStatusIndexByName(processStepName) {
    const stepStatus = this.get('stepStatus');
    return stepStatus.findIndex(step => {
      return step.get('processStepName') === processStepName ? step : undefined;
    });
  }

  getStepStatusIndexById(processStepId) {
    const stepStatus = this.get('stepStatus');
    return stepStatus.findIndex(step => {
      return step.get('processStepId') === processStepId ? step : undefined;
    });
  }

  isInProgress() {
    const stepStatus = this.get('stepStatus');
    if (!stepStatus.isEmpty()) {
      return stepStatus.find((step) => {
        const completeDateTime = step.get('completeDateTime');
        return !completeDateTime || false;
      });
    }
    return undefined;
  }

  static updateWorkflowsProcessSteps(workflows, processSteps) {
    let updatedWorkFlow = workflows;
    processSteps.forEach((step) => {
      const workflow = Workflow.getWorkflowByName(workflows, step.workflowName);
      const workflowIndex = Workflow.getWorkflowIndexByName(workflows, step.workflowName);
      const stepIndex = workflow.getStepStatusIndexByName(step.processName);
      let newStep = workflow.getStepStatusByName(step.processName);

      newStep = newStep.set('completeDateTime', step.completeDatetime);
      updatedWorkFlow = updatedWorkFlow.setIn([workflowIndex, 'stepStatus', stepIndex], newStep);
    });
    return updatedWorkFlow;
  }

  static stepIsComplete(step) {
    const completeDateTime = step.get('completeDateTime');
    return completeDateTime || false;
  }

  static getWorkflowByName(workflows, workflowName) {
	if(workflows){
        return workflows.find(workflow => {
          return workflow.get('workflowName') === workflowName ? workflow : undefined;
        });
	}
	return undefined;
  }

  static getWorkflowById(workflows, workflowId) {
    return workflows.find(workflow => {
      return workflow.get('workflowId') === workflowId ? workflow : undefined;
    });
  }

  static getWorkflowIndexByName(workflows, workflowName) {
    return workflows.findIndex(workflow => {
      return workflow.get('workflowName') === workflowName ? workflow : undefined;
    });
  }

  static getWorkflowIndexById(workflows, workflowId) {
    return workflows.findIndex(workflow => {
      return workflow.get('workflowId') === workflowId ? workflow : undefined;
    });
  }

  static getCurrentWorkflow(workflows) {
    return workflows.first();
  }

  static getWorkflowStepRoute(workflow, step) {
    const workflowName = workflow.get('workflowName');
    const processStepName = step.get('processStepName');
    const baseRoute = workflowsRoutes.getIn([`${ workflowName }`, 'baseRoute']);
    const stepRoute = workflowsRoutes.getIn([`${ workflowName }`, `${ processStepName }`]);
    return `${ baseRoute }${ stepRoute }`;
  }

  static getCurrentWorkflowRoute(workflow) {
    const workflowName = workflow.get('workflowName');
    const step = workflow.getCurrentStepStatus();
    const baseRoute = workflowsRoutes.getIn([`${ workflowName }`, 'baseRoute']);
    if (step) {
      const processStepName = step.get('processStepName');
      const stepRoute = workflowsRoutes.getIn([`${ workflowName }`, `${ processStepName }`]);
      return `${ baseRoute }${ stepRoute }`;
    }
    return `${ baseRoute }`;
  }
}

export const Workflows = (data) => {
  let workflows = new List();
  data.forEach((value) => {
    workflows = workflows.push(new Workflow(value));
  });
  return workflows;
};
